/** @jsx jsx */
import {css, jsx} from '@emotion/react';
import React, {useEffect} from 'react'; 
import { Dropdown } from '../../../components/dropdowns/dropdown';

export const ProgressBar = (({step: currentStep}) => {
	const steps = [ {'index': 0, 'step': "Upload File", 'active': false}, 
					{'index': 1, 'step': "View/Edit Schema", 'active': false}, 
					{'index': 2, 'step': "Done", 'active': false} ]

	const index: number = steps.findIndex(step => step['index'] === currentStep)
	if (index > -1) {
		for (let i = 0; i < steps.length; i++) {
			if (i <= index) {
				steps[i].active = true
			}
		}
	}

	return (
		<div>
			<ul css={progressBarCSS}>
				{steps.map(({step, active}) => (
					<li css={progressBarElementCSS} className={active ? "active" : ""} key={step}>{step}</li>
				))}
			</ul>
		</div>
	); 
});

// Reference: https://codepen.io/brendansparrow/pen/QjRmKv
const progressBarCSS = css`
	counter-reset: step;
	overflow: hidden;
	display: flex;
	width: 1000px; 
	padding:0; 
	position: relative; 
	margin: 0 auto;
    text-align: center; 
    padding-top: 25px;
    height: 100px; 
`; 

const progressBarElementCSS = css`
	
	list-style-type: none;
	color: #A7B6C2;
	font-size: 14px;
	width: 100%;	

	&:before {
		content: counter(step);
		counter-increment: step;
		width: 30px;
		display: block;
		font-size:14px;
		color: white;
		background: #A7B6C2;
		border-radius: 30px;
		line-height: 30px; 
		margin: 0 auto 5px auto;
	}

	&:after {
		top: 50%;
		width: 216px;
		height: 2px; 
		background: #A7B6C2; 
		content: '';
		position: absolute; 
		border-radius: 1px;
	}

	&:last-child:after {
		content:none; 
	}

	&.active {
		color: #5C7080;
		font-weight: bold; 
	}

	&.active::before {
		background: #2B95D6;
	}

	&.active:after {
		background: #2B95D6;
	}
`;